// Ring Modal
const openRingModal = document.getElementById('openRingModal');
const closeRingModal = document.getElementById('closeRingModal');
const ringModal = document.getElementById('ringModal');

if (openRingModal && ringModal) {
  openRingModal.addEventListener('click', function(event) {
    event.preventDefault();
    ringModal.style.display = 'block';
  });
}

if (closeRingModal && ringModal) {
  closeRingModal.addEventListener('click', function() {
    ringModal.style.display = 'none';
  });
}

// Bracelet Modal
const openBraceletModal = document.getElementById('openBraceletModal');
const braceletModal = document.getElementById('braceletModal');

if (openBraceletModal && braceletModal) {
  openBraceletModal.addEventListener('click', function(event) {
    event.preventDefault();
    braceletModal.style.display = 'block';
  });
}

// Size Guide Modal
const openModal = document.getElementById("openModal");
const closeModal = document.getElementById("closeModal");
const modalOverlay = document.getElementById("modalOverlay");
const sizeGuideModal = document.getElementById("sizeGuideModal");

if (openModal && modalOverlay && sizeGuideModal) {
  openModal.addEventListener("click", function(event) {
    event.preventDefault();  // Prevent default link behavior
    modalOverlay.style.display = "block";  // Show overlay
    sizeGuideModal.style.display = "block";  // Show modal
  });
}

if (closeModal && modalOverlay && sizeGuideModal) {
  closeModal.addEventListener("click", function() {
    modalOverlay.style.display = "none";  // Hide overlay
    sizeGuideModal.style.display = "none";  // Hide modal
  });
}

if (modalOverlay && sizeGuideModal) {
  modalOverlay.addEventListener("click", function() {
    modalOverlay.style.display = "none";  // Hide overlay
    sizeGuideModal.style.display = "none";  // Hide modal
  });
}
